import React, { useState,CSSProperties, memo, useCallback } from "react";
import { RiPencilFill } from "react-icons/ri";
import RouteModal from "../../../../Component/BasicComponents/Modal/RouteModal";
import BasicDataTable from "../../../../Component/BasicComponents/BasicDataTable";
import {FaEdit, FaPlus } from "react-icons/fa";
import { useGetOutletMappingList, useOutletCategoryTypes } from "../hooks/useCustomer";
import MappingModal from "../Modal/MappingModal";
import { useCategoryType } from "../../../ProductCatalogue/useProduct";




interface TableButtonProps {
    onClick: () => void;
    title?: string;
    style?: CSSProperties;
}

const TableButton: React.FC<TableButtonProps> = memo(({
  onClick,
  title = "Add Heads",
  style,
}) => {
  const defaultStyle: CSSProperties = {
    display: "flex",
    borderRadius: "20px",
    padding: "2px",
    width: "110px",
    height: "40px",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
  };

  return (
    <div>
      <button
        onClick={onClick}
        className="btn btn-info"
        style={{ ...defaultStyle, ...style }}>
        <FaPlus /> <span style={{ marginLeft: "5px" }}>{title}</span>
      </button>
    </div>
  );
});

const Data =[
    {
        Primary:'Aizwal Chemist',
        Category_Type:'Regualar',
        Price_Book:'Eye Care',
        is_Default :'No' ,
    },
    {
        Primary:'Hill Medical Store',
        Category_Type:'Regualar',
        Price_Book:'Eye Care',
        is_Default :'No' ,
    },
]


const TableColumns =( handleEdit:(row:any)=>void)=>[
    {
     name:'Primary',
     selector:(row:{PrimaryOutletName:string})=>row.PrimaryOutletName ,
     width:'160px'  
    },
    {
     name:'Category Type',
     selector:(row:{CategoryType:string})=>row.CategoryType,
     width:'130px'  

    },
    {
     name:'Price Book',
     selector:( row:{PricebookName:string})=>row.PricebookName,
     width:'160px'  

    },
    {
        name:'is Default',
        selector:(row:{Isdefault:string|number})=>row.Isdefault === 1 || row.Isdefault === '1' ? 'Yes' : 'No',
     width:'130px'  

    },

    {
        name:'Actions',
        cell:(row:any)=>(
          <div  className="d-flex align-items-center gap-2">
              <button className='btn btn-primary'  onClick={()=>handleEdit(row)}
                style={{borderRadius:'20px',padding:'2px',width:'80px',}}>
               <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
              </button>
          </div>
        )
    }

]

const PrimaryMappingTable =({Outlet_Id}:any)=>{
 const [isModal,setIsModal] = useState(false);
   const [mode, setmode] = useState<"add" | "edit">("add");
   const [selectedRow, setSelectedRow] = useState();
     const [pageState, setPageState] = useState({
     page: 1,
   });
   const [limitState, setLimitState] = useState({
     limit: 10,
   });
   const [search,setSearch]=useState({
     searchValue:''
   })

 const {data:mappingData}=useGetOutletMappingList({
  enabled:!!Outlet_Id,
  outletId:Outlet_Id,
  params:{
    page: pageState.page,
      limit: limitState.limit,
      search:search.searchValue
  }
 })



 
    const handleEdit =(row:any)=>{
       setIsModal(true);
    setmode("edit");
    setSelectedRow(row);
    } 

    const toggle =()=>{
         setIsModal(!isModal);
    }

      const oncloseModal = () => {
    setIsModal(false);
  };

    const handleAddMapping = useCallback(()=>{
            setIsModal(true);
    setmode("add");
    },[]) 

      const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
 
      };
  });
      setLimitState((prevState: any) => {
        return {
          ...prevState,
          limit: limit,
        };
      });
    
  };
  const handlePagination = (pageNo: number) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  }

   const handleSearch = (searchValue: any) => {
    setSearch((prevState: any) => {
      return {
        ...prevState,
        searchValue,
      };
    });
  }

    return (
        <>
        <BasicDataTable 
        paginationTotalRows={mappingData?.data?.Pagination?.TotalMappings}
          Title='Primary Mapping'
          columns={TableColumns(handleEdit)}
          data={mappingData?.data.OutletMapping||[]}  
             onChangePage={(pageNo: number) => {
             handlePagination(pageNo);
           }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
           handleonChangeRowsPerPage(newPerPage, page);
         }}
            handleSearch={(val: any) => {
          handleSearch(val);
        }}
          headerContent={
            <TableButton
              onClick={() => handleAddMapping()}
              title="Add Mapping"
              style={{ marginRight: "8px",width:'134px',height:'34px' }}
            />
          }
        />
      <RouteModal
        size="md"
        toggle={toggle}
        isOpen={isModal}
        title={mode == "add" ? "Add Mapping" : "Edit Mapping"}
        content={
          <MappingModal
            mode={mode}
            modalClose={oncloseModal}
            initialData={selectedRow}
            OutletId={Outlet_Id}
          />
        }
      />
      </>
    )
}

export default PrimaryMappingTable